import cc from 'store/util/createReduxConstant';

export const FETCH_OPEN_OPPORTUNITIES = cc('paperwork/FETCH_OPEN_OPPORTUNITIES');
export const FETCH_OPEN_OPPORTUNITIES_SUCCESS = cc('paperwork/FETCH_OPEN_OPPORTUNITIES_SUCCESS');
export const FETCH_OPEN_OPPORTUNITIES_FAIL = cc('paperwork/FETCH_OPEN_OPPORTUNITIES_FAIL');
